var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-datepicker',{staticClass:"mb-1",attrs:{"disabled":_vm.disabled,"required":"","size":"sm","locale":"es"},model:{value:(_vm.modelDate),callback:function ($$v) {_vm.modelDate=$$v},expression:"modelDate"}})}
var staticRenderFns = []

export { render, staticRenderFns }